import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaTypePipe } from './pipes/mediaType.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';



@NgModule({
  declarations: [MediaTypePipe, SafeHtmlPipe],
  imports: [
    CommonModule
  ],
  exports: [MediaTypePipe, SafeHtmlPipe]
})
export class SharedModule { }
